<template>
  <div>
    <v-app class="rounded">
      <v-container fluid>
        <v-card-title>
          <!--                                    v-if="$can('transaction_create')"-->
          <!--          <v-btn @click="$router.push({name: 'admin.customers'})" class="btn-back">-->
          <!--            <span class="flaticon2-reply icon-lg"></span>-->
          <!--            بازگشت-->
          <!--          </v-btn>-->
          <v-spacer />
          {{ $t($route.meta.title) }}
          <v-spacer />
          <!--          <v-btn :loading="loading" @click="reloadTable(tableProps)" class="btn-update">-->
          <!--            <v-icon>mdi-refresh</v-icon>-->
          <!--            به روزرسانی-->
          <!--          </v-btn>-->
        </v-card-title>
        <v-divider />
        <div class="row">
          <div class="col-md-12 p-5">
            <data-table
              orderDir="desc"
              :data="data"
              :columns="columns"
              :debounce-delay="5000"
              :translate="translates"
              :per-page="perPages"
              @on-table-props-changed="reloadTable"
            >
              <div slot="filters" slot-scope="{ tableFilters, perPage }">
                <div class="row mb-2">
                  <div class="col-md-4">
                    <v-select
                      v-model="tableFilters.length"
                      :items="perPage"
                      item-value="page"
                      item-text="page"
                      outlined
                      dense
                    >
                    </v-select>
                    <v-btn dense class="btn-management" @click="showUsers()">
                      <v-icon>mdi-account-circle</v-icon>
                      تغییر مالکیت
                    </v-btn>
                  </div>
                  <div class="col-md-4"></div>
                  <div class="col-md-4">
                    <v-text-field
                      name="name"
                      outlined
                      dense
                      append-icon="search"
                      label="جستوجو"
                      v-model="tableFilters.search"
                      placeholder="جستوجو"
                    ></v-text-field>
                  </div>
                </div>
              </div>
            </data-table>
          </div>
        </div>
      </v-container>
      <v-dialog v-model="dialog" persistent max-width="400px">
        <v-card>
          <v-card-title>
            <span class="text-h5">تغییر مالکیت</span>
            <v-spacer></v-spacer>
            <v-btn
              small
              icon
              rounded
              @click="dialog = false"
              class="ml-1 text-danger"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <hr />
          <v-card-text>
            <v-container>
              <v-row>
                <v-flex xs12 sm12 md12 lg12 xl12 class="p-2">
                  <v-autocomplete
                    :items="users"
                    dense
                    filled
                    item-text="username"
                    clearable
                    item-value="id"
                    :error-messages="errors.user_id"
                    v-model="owner_id"
                    label="ادمین ها"
                  >
                    <template slot="selection" slot-scope="{ item }">
                      {{ item.name }} {{ item.lastName }} - {{ item.username }}
                    </template>
                    <template slot="item" slot-scope="{ item }">
                      {{ item.name }} {{ item.lastName }} - {{ item.username }}
                    </template>
                  </v-autocomplete>
                </v-flex>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="btn-cancel" @click="dialog = false"> انصراف </v-btn>
            <v-btn class="btn-update" @click="changeOwner">
              <v-icon>mdi-update</v-icon>
              بروزرسانی
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-app>
  </div>
</template>

<script>
import i18n from "../../../../core/plugins/TitleRibbon/plugins/EasyModal/i18n";
import Button from "@/view/pages/Button";
import CheckboxFild from "@/view/pages/admin/users/CheckboxFild";

export default {
  i18n,
  name: "CustomerOwner",
  props: ["user_id"],
  data() {
    return {
      dialog: false,
      users: [],
      errors: [],
      selectedRows: [],
      owner_id: null,
      columns: [
        {
          label: `<input type="checkbox" id="select_all" onclick="window.Vue.$emit('selectAllListCheckBox', this)"/>`,
          component: CheckboxFild,
          event: "change",
          handler: this.change,
        },
        {
          label: "ردیف",
          transform: (val) => {
            let row = this.data.current_page - 1;
            row = row * this.data.per_page;
            return row + val.row + 1;
          },
        },
        {
          label: "شناسه",
          name: "id",
          orderable: true,
        },
        {
          label: "نام",
          name: "first_name",
          orderable: true,
        },
        {
          label: "نام خانوادگی",
          name: "last_name",
          orderable: true,
        },
        {
          label: "شغل",
          name: "job",
          orderable: true,
        },
        {
          label: "شماره تماس",
          name: "phone_number",
          orderable: true,
        },
        {
          label: "مدیریت",
          name: "actions",
          component: Button,
          handler: this.actions,
          event: "action",
          meta: {
            permission_prefix: "customers_",
            buttons: [
              {
                label: "ویرایش",
                name: "edit",
                icon: "pencil-alt",
                class: "btn-edit",
              },
              {
                label: "تاریخچه",
                name: "history",
                icon: "history",
                class: "btn-history",
              },
            ],
          },
        },
      ],
      data: {},
      url: "customer",
      tableProps: {
        search: "",
        length: 10,
        column: "id",
        dir: "asc",
      },
      loading: false,
    };
  },
  mounted() {
    this.getCustomers();
    window.Vue.$on("selectAllListCheckBox", (e) => {
      this.selectAll(e.checked);
    });
  },
  methods: {
    selectAll(c) {
      window.Vue.$emit("selectedAllCheckbox", c);
    },
    change(data, checked) {
      if (checked) {
        this.selectedRows.push(data.id);
      } else {
        let index = this.selectedRows.indexOf(data.id);
        this.selectedRows = [
          ...this.selectedRows.slice(0, index),
          ...this.selectedRows.slice(index + 1, this.selectedRows.length),
        ];
      }
      window.document.querySelector("#select_all").checked =
        this.selectedRows.length == this.data.data.length;
    },

    async changeOwner() {
      if (await this.$modal.yesNo("آیا از حذف مطمعین هستید؟")) {
        this.$modal.showLoading();
        this.requestApiPost("customer/change-owner", {
          user_id: this.owner_id,
          current_id: this.user_id,
          customer_id: this.selectedRows,
        })
          .then(({ data }) => {
            this.dialog = false;
            this.errors = [];
            this.$modal.hideLoading();
            this.$toast.success("انتقال با موفقیت صورت گرفت.");
          })
          .catch(({ response }) => {
            this.$modal.hideLoading();
            this.errors = response.data.errors;
          });
      }
    },
    async showUsers() {
      if (
        this.selectedRows.length > 0 ||
        (await this.$modal.yesNo(
          "انتقال مالکیت همه مشتریان",
          "آیا از انتقال کل مشتریان مطمعن هستید؟"
        ))
      ) {
        this.dialog = true;
        this.$modal.showLoading();
        this.requestApiGet("user/supports")
          .then(({ data }) => {
            this.$modal.hideLoading();
            this.users = data;
          })
          .catch(({ response }) => {
            this.$modal.hideLoading();
          });
      }
    },
    getCustomers(url = this.url, query = this.tableProps) {
      if (query.search === "") this.$modal.showLoading();
      this.loading = true;
      this.requestApiGet(`${url}/${this.user_id}`, query)
        .then(({ data }) => {
          this.$modal.hideLoading();
          this.loading = false;
          this.data = data;
        })
        .catch(({ response }) => {
          this.$modal.hideLoading();
          this.loading = false;
        });
    },
    reloadTable(tableProps) {
      this.getCustomers(this.url, tableProps);
    },
    actions(data, type) {
      console.log(type);
      this[type](data);
    },
    edit(data) {
      this.$router.push({
        name: "admin.customers.edit",
        params: { id: data.id },
      });
    },
    history(data) {
      this.$router.push({
        name: "admin.customers.history",
        params: { phone: data.phone_number },
      });
    },
  },
};
</script>

<style scoped></style>
